module.exports = __webpack_public_path__ + "img/icon-white-16.2047c01f.svg";